import { Directive, effect, inject, input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { Permission } from '../models/permission.model';

@Directive({
  selector: '[appIfHasPermission]',
  standalone: true,
})
export class IfHasPermissionDirective {
  readonly permissions = input<Permission[]>([], {
    alias: 'appIfHasPermission',
  });

  private templateRef = inject(TemplateRef<any>);
  private viewContainer = inject(ViewContainerRef);
  private authService = inject(AuthService);

  private hasView = false;

  constructor() {
    effect(() => {
      const isAllowed = this.authService.hasPermission(this.permissions());

      if (isAllowed && !this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      }

      if (!isAllowed && this.hasView) {
        this.viewContainer.clear();
        this.hasView = false;
      }
    });
  }
}
